import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
import Select from 'grommet/components/Select';
import React from 'react';
import TableSample from "./tablesample.js"

import Spinning from 'grommet/components/icons/Spinning';
import Label from 'grommet/components/Label';


class DonutData extends React.Component {
    constructor() {
        super();
        this._onClick = this._onClick.bind(this);
        this.state = { 
            dataNames: [],
            uploadfile: false,
            file: [],
            filepredict: [],
            splitData: "80%-20%",
            spinningFlag: false,
            rows: 0,
            lengthArrays: 0,
            currentValue: [],
            options: [],
            currentSelection: "",
            dataObjectParsed: [],
            jsonoutput: []
        }
    }
    _onChange(event) {
        this.setState({currentValue: event.value})
    }
    componentDidMount() {            
            let input = document.getElementById('dealCsvTrain');
            let input2 = document.getElementById('dealCsvPredict');
            const that = this;
            if (input) {
                input.addEventListener('change', function() {
                    that.setState({spinningFlag: true})
                    if (this.files && this.files[0]) {
    
                        var myFile = this.files[0];
                        var reader = new FileReader();
                        
                        reader.addEventListener('load', function (e) {
                            let csvdata = e.target.result;
                            that.parseData(csvdata, "train"); // calling function for parse csv data 
                        });
                        
                        reader.readAsBinaryString(myFile);
                    }
                });
            }
            if (input2) {
                input2.addEventListener('change', function() {
                    that.setState({spinningFlag: true})
                    if (this.files && this.files[0]) {
    
                        var myFile = this.files[0];
                        var reader = new FileReader();
                        
                        reader.addEventListener('load', function (e) {
                            let csvdata = e.target.result;
                            that.parseData(csvdata, "predict"); // calling function for parse csv data 
                        });
                        
                        reader.readAsBinaryString(myFile);
                    }
                });
            }
    }
    _onChangeSelect(field) {
        let jsonoutput = []
        if (Array.isArray(this.state.dataObjectParsed[field.value])) {
            const rows = this.state.dataObjectParsed[field.value] ? this.state.dataObjectParsed[field.value].length : 0
            const keys = this.state.dataObjectParsed[field.value][0] ? Object.keys(this.state.dataObjectParsed[field.value][0]) : ["none"]
            let lengthArrays = 0;
            if (field.value === "none") {
                //this.state.dataObjectParsed
            } else {
                lengthArrays = keys.length;
                keys.forEach((input, index)=>{
                    jsonoutput[index] = []
                })
                this.state.dataObjectParsed[field.value].forEach((input, index)=>{
                    keys.forEach((inputKeys, index2)=>{
                        jsonoutput[index2].push(input[inputKeys])
                    })
                })
            }
            this.submitFile(jsonoutput, rows, "train", lengthArrays, keys, field.value)
        }
        
        //this.setState({currentSelection: field.value, jsonoutput})


        /* const {dataObjectParsed} = this.state;
        let finalObjectNew = this.state.finalObject
        finalObjectNew[field] = event.value
        this.setState({finalObject: finalObjectNew}) */
    }
    parseData(data, type) {
        let finalArray =[]
        this.setState({spinningFlag: true})
        let parsedata = [];
        let textIfApply = []

        const dataObjectParsed = JSON.parse(data.replace(/(\r\n|\n|\r|\s)/gm,""));
        console.log(dataObjectParsed)
        const keys = Object.keys(dataObjectParsed)
        console.log(keys)
        //const finalKeys = Object.assign({}, options)
        //keys.push("none")
        this.setState({options: keys, spinningFlag: false, dataObjectParsed})
        /* let newLinebrk = data.split("\n");
        for(let i = 0; i < newLinebrk.length; i++) {
            parsedata.push(newLinebrk[i].split(","))
        }
                
       const lengthArrays = newLinebrk[0].split(",").length
        for (let i = 0; i < lengthArrays; i++) {
            let parsedata2 = []   
            console.log(this.state.currentValue[0])     
            newLinebrk.forEach((input, index) => {
                const line = input.split(",")[i]
                const lineNum = parseInt(line)
                if (this.state.currentValue[0] === "First row are names" && index === 0) {
                    textIfApply.push(line);
                } else if (isNaN(lineNum)) {
                    //console.warn("Detecting strings instead of number type in the file attached. Remove null values and pass plain numbers")
                    parsedata2.push(line)
                } else if (!isNaN(lineNum)) {
                    parsedata2.push(lineNum)
                }
            })
            finalArray.push(parsedata2)   
        }
        const rows = this.state.currentValue[0] === "First row are names" ? newLinebrk.length -1 : newLinebrk.length;
        console.log(rows) */
        //this.submitFile(finalArray, rows, type, lengthArrays, textIfApply)
    }
    submitFile(finalArray, rows, type, lengthArrays, textIfApply, fieldValue) {
        //this.setState({ uploadfile: true, file: finalArray, dataNames: textIfApply})
        if (type === "train") {
            this.setState({ uploadfile: true, file: finalArray, spinningFlag: false, rows, lengthArrays, dataNames: textIfApply, currentSelection: fieldValue})
        } else {
            this.setState({ uploadfile: true, filepredict: finalArray, spinningFlag: false, rows, lengthArrays, currentSelection: fieldValue})
        }
        
    }
    _onClick(dataJsonParsed, filepredict, dataNames) {
        const {splitData, rows, lengthArrays} = this.state;
        let dataNamesObj = {}
        for (let i = 0; i < lengthArrays; i++) {
            if (dataNames[i]) {
                dataNamesObj[`positionname${i + 1}`] = dataNames[i]
            } else {
                dataNamesObj[`positionname${i + 1}`] = `variable ${i}`
            }
        }
        this.props.onSubmit(dataJsonParsed, splitData, rows, filepredict, "", dataNamesObj)
    }
    _onChangeSplit(field) {
        this.setState({splitData: field.value})
    }
    render() {
        const {dataNames, file, filepredict, splitData, spinningFlag, currentValue, options, currentSelection} = this.state;
        let dataJsonParsed = file, spinningComponent
        if (spinningFlag) {
            spinningComponent = <div style={{position: "fixed", backgroundColor: "white", top: "0px", 
            bottom: "0px", right: "0px", left: "0px", opacity: "0.5", paddingTop: "30%",
            zIndex: "500", textAlign: "center"}}>
                <Label>Loading...</Label>
                <Spinning size={"huge"}/>
            </div>
        } else {
            spinningComponent = <div></div>
        }
        console.log(file)
        return (
            <div>
                {spinningComponent}
                <Box direction='row'
                    justify='start'
                    align='left'
                    wrap={true}
                    reverse={false}
                    margin='none'>
                    <Box direction='row'
                        align='left'
                        wrap={true}
                        pad='small'
                        margin='none'>
                        <Label>Upload File</Label>
                    </Box>
                    <Box direction='row'
                        align='right'
                        wrap={true}
                        pad='small'
                        margin='none'>
                        <input type="file" id="dealCsvTrain" style={{padding: "11px 11px"}}/>
                    </Box>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'>
                        <Select placeHolder='None'
                            options={options}
                            placeHolder={"Select Property"}
                            value={[currentSelection]}
                            onChange={this._onChangeSelect.bind(this)} />
                    </Box>
                    {/* <Box direction='row'
                        align='right'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        <Select 
                                inline={true}
                                multiple={true}
                                options={["First row names"]}
                                value={currentValue}
                                onChange={this._onChange.bind(this)} 
                        />
                    </Box> */}
                   
                    {file[0] && currentSelection && <Box direction='row'
                        align='right'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        <Button 
                            label='Submit'
                            type='submit'
                            primary={true}
                            onClick={this._onClick.bind(this, dataJsonParsed, filepredict, dataNames)} 
                        />
                    </Box>}
                    {/* <Box direction='row'
                        align='left'
                        wrap={true}
                        pad='small'
                        margin='none'>
                        <Label>Predict Data</Label>
                    </Box>
                    <Box direction='row'
                        align='right'
                        wrap={true}
                        pad='small'
                        margin='none'>
                        <input type="file" id="dealCsvPredict" style={{padding: "11px 11px"}}/>
                    </Box>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        Split (%) Train vs Test &nbsp; &nbsp;
                        <Select placeHolder='None'
                            options={['80%-20%']}
                            placeHolder={"Type"}
                            value={splitData}
                            onChange={this._onChangeSplit.bind(this)} />
                    </Box> */}
                    
                </Box>
                
                {file[0] && <div><div>Results (First 1000 rows)</div><TableSample iterator={file} dataNames={dataNames}/></div>}
            </div>
        );
    }
}

export default DonutData;



// WEBPACK FOOTER //
// ./src/samples/data/fileinputJson.js